import styled from 'styled-components';
import { Colors, Media } from 'enums';

export const RatingBadgeStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  background: ${Colors.white};
  border-radius: 6px;

  @media ${Media.mobile} {
    padding: 6px;
  }
`;
